export const FETCH_TASKS_RESOLVED = "FETCH_TASKS_RESOLVED";
export const UPDATE_TASKS_RESOLVED = "UPDATE_TASKS_RESOLVED";
export const FETCH_TASK_RESOLVED = "FETCH_TASK_RESOLVED";
export const FETCH_TASKS_REPORTS_RESOLVED = "FETCH_TASKS_REPORTS_RESOLVED";
export const UPDATE_MULTIPLE_TASKS_RESOLVED = "UPDATE_MULTIPLE_TASKS_RESOLVED";
export const FETCH_TASK_IMPORTS_RESOLVED = "FETCH_TASK_IMPORTS_RESOLVED";
export const FETCH_REVERTED_TASK_IMPORT_RESOLVED = "FETCH_REVERTED_TASK_IMPORT_RESOLVED";
